import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';

export const InnerWrapper = styled(Flex)`
  flex-direction: column;
  width: 100%;

  ${({ theme }) => css`
    max-width: ${theme.breakpoints.lg};
    padding: ${theme.spacing(0, 2, 0)};

    ${theme.media.md.up} {
      padding: ${theme.spacing(0, 3, 0)};
    }
  `}
`;

export const RightContent = styled(Flex)`
  align-items: center;
`;
